module.exports = __webpack_public_path__ + "img/skilled_service.e0c79b47.svg";